import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'app',
  initialState: { bootstrapped: false },
  reducers: {
    markBootstrapped(state) { state.bootstrapped = true; },
    resetBootstrap(state) { state.bootstrapped = false; }
  }
});

export const { markBootstrapped, resetBootstrap } = slice.actions;
export const selectBootstrapped = s => s.app.bootstrapped;
export default slice.reducer;
